import React, { FC, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Navigate, Routes, useNavigate, useLocation } from "react-router";
import { Tabs } from "../../../components";
import {
  Container,
  InstanceName,
  NavWrapper,
  HeadWrapper
} from './styles'

const Versions = React.lazy(() => import('./components/versions'));
const VersionDetail = React.lazy(() => import('./components/versions/detail'));
const Images = React.lazy(() => import('./components/images'));
const Addons = React.lazy(() => import('./components/addons'));
const AddonDetail = React.lazy(() => import('./components/addons/detail'));
const Networkings = React.lazy(() => import('./components/networkings'));
const NetworkingDetail = React.lazy(() => import('./components/networkings/detail'));
const Operations = React.lazy(() => import('./components/operations'));
const OperationDetail = React.lazy(() => import('./components/operations/detail'));
const Workers = React.lazy(() => import('./components/workers'));
const WorkerDetail = React.lazy(() => import('./components/workers/detail'));

const ClusterSettings: FC = () => {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [activeTab, setActiveTab] = useState<string>('versions');
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    tabs.forEach((item) => {
      if (pathSegments.includes(item.slug)) {
        setActiveTab(item.slug);
      }
    });
  }, [location]);

  const [tabs] = useState([
    { title: t("VERSIONS"), slug: 'versions', id: '1' },
    // { title: t("IMAGES"), slug: 'images', id: '2' },
    { title: t("ADDONS_TAB"), slug: 'addons', id: '3' },
    { title: t("NETWORKINGS"), slug: 'networkings', id: '4' },
    { title: t("OPERATIONS_TAB"), slug: 'operations', id: '5' },
    { title: t("WORKERS"), slug: 'workers', id: '6' },
  ]);

  return (
    <Container>
      <HeadWrapper>
        <InstanceName>
          {t("CLUSTER_SETTINGS")}
        </InstanceName>
      </HeadWrapper>
      <NavWrapper>
        <div>
          <Tabs
            tabs={tabs}
            size='display'
            blockNavigate
            location={activeTab}
            onChange={(e: string) => {
              navigate(`/settings/clusters/${e}`)
            }}
          />
        </div>
      </NavWrapper>
      <React.Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Navigate replace to="versions" />} />
          <Route path="/versions" element={<Versions />} />
          <Route path="/versions/:versionId" element={<VersionDetail />} />
          <Route path="/images" element={<Images />} />
          <Route path="/addons" element={<Addons />} />
          <Route path="/addons/:addonId" element={<AddonDetail />} />
          <Route path="/networkings" element={<Networkings />} />
          <Route path="/networkings/:networkingId" element={<NetworkingDetail />} />
          <Route path="/operations" element={<Operations />} />
          <Route path="/operations/:operationId" element={<OperationDetail />} />
          <Route path="/workers" element={<Workers />} />
          <Route path="/workers/:workerId" element={<WorkerDetail />} />
        </Routes>
      </React.Suspense>
    </Container>
  )
}

export default ClusterSettings
